import { forwardRef } from 'react';

import { IconProps } from '@sternum/web/icons/icons.types';

export const ErrorSolidIcon = forwardRef<SVGSVGElement, IconProps>(function ErrorSolidIcon(
  { color, height = 18, width = 18, ...props },
  ref,
) {
  return (
    <svg
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.6087 3.465L10.3781 0.378C9.52394 -0.126 8.46725 -0.126 7.60429 0.378L2.3825 3.465C1.52834 3.969 1 4.905 1 5.922V12.078C1 13.086 1.52834 14.022 2.3825 14.535L7.6131 17.622C8.46725 18.126 9.52394 18.126 10.3869 17.622L15.6175 14.535C16.4717 14.031 17 13.095 17 12.078V5.922C16.9912 4.905 16.4629 3.978 15.6087 3.465ZM8.33517 5.175C8.33517 4.806 8.63456 4.5 8.9956 4.5C9.35663 4.5 9.65603 4.806 9.65603 5.175V9.9C9.65603 10.269 9.35663 10.575 8.9956 10.575C8.63456 10.575 8.33517 10.269 8.33517 9.9V5.175ZM9.80572 13.167C9.76169 13.275 9.70006 13.374 9.6208 13.464C9.4535 13.635 9.23335 13.725 8.9956 13.725C8.88112 13.725 8.76665 13.698 8.66098 13.653C8.5465 13.608 8.45845 13.545 8.37039 13.464C8.29114 13.374 8.2295 13.275 8.17666 13.167C8.13264 13.059 8.11502 12.942 8.11502 12.825C8.11502 12.591 8.20308 12.357 8.37039 12.186C8.45845 12.105 8.5465 12.042 8.66098 11.997C8.98679 11.853 9.37424 11.934 9.6208 12.186C9.70006 12.276 9.76169 12.366 9.80572 12.483C9.84975 12.591 9.87617 12.708 9.87617 12.825C9.87617 12.942 9.84975 13.059 9.80572 13.167Z"
        fill={color || 'currentColor'}
      />
    </svg>
  );
});
